import { createFeatureSelector, createSelector, MemoizedSelector } from '@ngrx/store';
import {StoreKeys} from '../../models/store-keys';
import { CriticalDataState } from './reducer/critical-data.reducer';


export const selectCriticalDataFeature: MemoizedSelector<NonNullable<unknown>, CriticalDataState> = createFeatureSelector(StoreKeys.CRITICAL_DATA);
export const selectCriticalDataDatas = createSelector(selectCriticalDataFeature, state => state.datas);

